const SupportedCourier = () =>
  import(/* webpackChunkName: "supported" */ '@/pages/supported/courier.vue')

export default {
  name: 'SupportedCourier',
  path: 'courier',
  meta: {
    label: 'supportedCourier',
    auth: 'courier'
  },
  component: SupportedCourier
}
